/* eslint-disable no-else-return */
// Copyright (c) 2016 Deere & Company

import './transfer-search-result.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import PipStatus from '../../shared/components/pip-status';
import ProductImage from './../../../shared/components/product-image';
import RecommendationStatus from '../../shared/components/recommendation-status';
import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';
import TransferModal from './modal';
import TranslatedTextArea from '../../../shared/components/translated-text-area';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {getStore} from '../../../store-factory';
import {translate} from '../../../shared/services/translation-service';

class TransferSearchResult extends React.Component {

    constructor() {

        super();
        this.handleAccept = this.handleAccept.bind(this);
        this.handleDecline = this.handleDecline.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleConfirmation = this.handleConfirmation.bind(this);
        this.handleRecommendBlur = this.handleRecommendBlur.bind(this);
        this.handleRecommendChange = this.handleRecommendChange.bind(this);
        this.handleOpenConfirmationModal = this.handleOpenConfirmationModal.bind(this);
        this.handleCloseConfirmationModal = this.handleCloseConfirmationModal.bind(this);
        this.handleRejctedReasonChange = this.handleRejctedReasonChange.bind(this);
        this.handleRejctedReasonInputChange = this.handleRejctedReasonInputChange.bind(this);

    }

    state = {
        showConfirmUndo: false,
        showRejectReasonInput: false
    };

    componentWillMount() {

        this.setState({
            approverComment: this.props.transfer.approverComment
        });

    }

    handleAccept() {

        const newTransfer = {...this.props.transfer};

        if (newTransfer.recommendation && newTransfer.recommendation.recommendationAccountComments) {

            newTransfer.approverComment = newTransfer.recommendation.recommendationAccountComments;

        }

        newTransfer.status = 'ACCEPTED';

        this.props.updateStatusAction(newTransfer);

    }

    handleConfirmation() {

        const newTransfer = {...this.props.transfer};

        newTransfer.approverComment = newTransfer.rejectReason;

        newTransfer.status = 'REJECTED';

        this.props.updateStatusAction(newTransfer);
        document.body.classList.remove('warranty-modal-is-open');

        this.setState({showConfirmUndo: false});

    }
    handleOpenConfirmationModal() {

        document.body.classList.add('warranty-modal-is-open');

        this.setState({showConfirmUndo: true});

    }

    handleCloseConfirmationModal() {

        const newTransfer = {...this.props.transfer};

        newTransfer.rejectReason = '';

        this.props.updateRejectedReason(newTransfer);
        document.body.classList.remove('warranty-modal-is-open');
        this.setState({showConfirmUndo: false});
        this.setState({showRejectReasonInput: false});

    }

    handleRejctedReasonChange = event => {

        const newTransfer = {...this.props.transfer};

        if (event === 'Other (comments required)') {

            newTransfer.rejectReason = '';
            this.setState({showRejectReasonInput: true});
            this.props.updateRejectedReason(newTransfer);

        } else {

            newTransfer.rejectReason = event;
            this.setState({showRejectReasonInput: false});
            this.props.updateRejectedReason(newTransfer);

        }

    }

    handleRejctedReasonInputChange = event => {

        const newTransfer = {...this.props.transfer};

        newTransfer.rejectReason = event;

        this.props.updateRejectedReason(newTransfer);

    }

    handleDecline() {

        const newTransfer = {...this.props.transfer};

        newTransfer.status = 'REJECTED';

        this.props.updateStatusAction(newTransfer);

    }

    handleChange(event) {

        this.setState({
            approverComment: event.target.value
        });

    }

    handleBlur(event) {

        const newTransfer = {...this.props.transfer};

        newTransfer.approverComment = event.target.value;

        this.props.updateCommentAction(newTransfer);

    }

    handleRecommendChange(event) {

        this.setState({
            recommendationAccountComments: event.target.value
        });

    }

    handleRecommendBlur(event) {

        const newTransfer = {...this.props.transfer};

        newTransfer.recommendation.recommendationAccountComments = event.target.value;

        this.props.updateCommentAction(newTransfer);

    }

    render() {

        if (this.props.transfer.isRecommendation) {

            const rejectedResons = getStore().getState().transferApprovals.rejectedReason;

            return (
                <section className='transfer-search-result'>
                    <section>
                        <div className='product-image'>
                            <ProductImage
                                imageURL={this.props.transfer.product.imageUrl}
                                placeHolderText={this.props.transfer.product.baseMachineCode}
                            />
                        </div>
                        <main>
                            <div className='product-header'>
                                <Link
                                    className='product-title'
                                    to={`/products/${this.props.transfer.product.pin}`}
                                >
                                    {this.props.transfer.product.pin}
                                </Link>
                                {this.props.transfer.recommendation.recommendationDate &&
                                <RecommendationStatus
                                    currentDate={Date.now()}
                                    recommendedDate={this.props.transfer.recommendation.recommendationDate}
                                />
                            }
                            </div>
                            <div className='data-pairs'>
                                <div className='row'>
                                    <LabeledString
                                        className='recommendation'
                                        data={this.props.transfer.recommendation.recommendation}
                                        label='RECOMMENDATION'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='recommendation-date'
                                        data={buildDate(this.props.transfer.recommendation.recommendationDate)}
                                        label='RECOMMENDATION_DATE'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='recommended_account'
                                        data={buildDealer(this.props.transfer.newDealer)}
                                        label='RECOMMENDED_ACCOUNT'
                                    />
                                    <LabeledString
                                        className='model'
                                        data={this.props.transfer.recommendation.workOrderNumber}
                                        label='WORK_ORDER'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='reason'
                                        data={this.props.transfer.recommendation.reason}
                                        label='REASON'
                                    />
                                    <LabeledString
                                        className='reason_event_number'
                                        data={this.props.transfer.recommendation.reasonEventNumber}
                                        label='REASON_EVENT_NUMBER'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='customer'
                                        data={this.props.transfer.product.customerSummary.displayName}
                                        label='CUSTOMER'
                                    />
                                    <LabeledString
                                        className='model'
                                        data={this.props.transfer.product.model}
                                        label='MODEL'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='last_seen_in_aor'
                                        data={buildDate(this.props.transfer.recommendation.lastSeenInAor)}
                                        label='LAST_SEEN'
                                    />
                                    <LabeledString
                                        className='connected_machine'
                                        data={this.props.transfer.recommendation.connectedMachine ? translate('YES') : translate('NO')}
                                        label='CONNECTED_MACHINE'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='estimated_hours'
                                        data={this.props.transfer.recommendation.estimatedHours}
                                        label='ESTIMATED_HOURS'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                    <footer>
                        <span className='recommend-comment'>
                            <TranslatedTextArea
                                maxLength={119}
                                onBlur={this.handleRecommendBlur}
                                onChange={this.handleRecommendChange}
                                placeholder='ENTER_COMMENTS_BEFORE_ACCEPTING'
                                rows={4}
                                value={this.state.recommendationAccountComments}
                            />
                        </span>
                        <section className='button-group'>
                            <button
                                className='secondary'
                                onClick={this.handleOpenConfirmationModal}
                            >
                                <FormattedMessage id='REJECT'/>
                            </button>
                            <button
                                className='primary'
                                onClick={this.handleAccept}
                            >
                                <FormattedMessage id='ACCEPT'/>
                            </button>
                            <TransferModal
                                isOpen={this.state.showConfirmUndo}
                                isRejectReasonOther={this.state.showRejectReasonInput}
                                onClose={this.handleCloseConfirmationModal}
                                onConfirm={this.handleConfirmation}
                                onRejectReasonChange={this.handleRejctedReasonChange}
                                onRejectedReasonInputChange={this.handleRejctedReasonInputChange}
                                rejectedResons={rejectedResons}
                                title='TRANSFER_REJECTED'
                                transfer={this.props.transfer}
                            />
                        </section>
                    </footer>
                </section>
            );

        } else {

            return (
                <section className='transfer-search-result'>
                    <section>
                        <div className='product-image'>
                            <ProductImage
                                imageURL={this.props.transfer.product.imageUrl}
                                placeHolderText={this.props.transfer.product.baseMachineCode}
                            />
                        </div>
                        <main>
                            <div className='product-header'>
                                <Link
                                    className='product-title'
                                    to={`/products/${this.props.transfer.product.pin}`}
                                >
                                    {this.props.transfer.product.pin}
                                </Link>
                                {this.props.transfer.product.pipIndicator.status &&
                                <PipStatus
                                    pin={this.props.transfer.product.pin}
                                    pipIndicator={this.props.transfer.product.pipIndicator}
                                />
                            }
                            </div>
                            <div className='data-pairs'>
                                <div className='row'>
                                    <LabeledString
                                        className='current-dealer'
                                        data={buildDealer(this.props.transfer.currentDealer)}
                                        label='CURRENT_DEALER_LOCATION'
                                    />
                                    <LabeledNode
                                        className='build-user-name'
                                        data={this.props.transfer.requestedBy.buildUserName() ||
                                        <FormattedMessage id='NO_USER_FOUND'/>}
                                        label='REQUESTED_BY'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledString
                                        className='new-dealer'
                                        data={buildDealer(this.props.transfer.newDealer)}
                                        label='NEW_DEALER_LOCATION'
                                    />
                                    <LabeledString
                                        className='request-date'
                                        data={buildDate(this.props.transfer.requestDate)}
                                        label='REQUESTED_DATE'
                                    />
                                </div>
                                <div className='row'>
                                    <LabeledNode
                                        className='customer-link-item'
                                        data={this.props.transfer.product.customerSummary.displayName}
                                        label='CUSTOMER'
                                    />
                                </div>
                            </div>
                        </main>
                    </section>
                    <footer>
                        <span className='reason-for-change'>
                            <textarea
                                disabled={true}
                                rows={4}
                                value={this.props.transfer.reasonForChange}
                            />
                        </span>
                        <span className='approver-comment'>
                            <TranslatedTextArea
                                maxLength={119}
                                onBlur={this.handleBlur}
                                onChange={this.handleChange}
                                placeholder='ENTER_COMMENTS_BEFORE_ACCEPTING'
                                rows={4}
                                value={this.state.approverComment}
                            />
                        </span>
                        <section className='button-group'>
                            <button
                                className='secondary'
                                onClick={this.handleDecline}
                            >
                                <FormattedMessage id='REJECT'/>
                            </button>
                            <button
                                className='primary'
                                onClick={this.handleAccept}
                            >
                                <FormattedMessage id='ACCEPT'/>
                            </button>
                        </section>
                    </footer>
                </section>
            );

        }

    }

}

TransferSearchResult.displayName = 'TransferSearchResult';
TransferSearchResult.propTypes = {
    actions: PropTypes.object.isRequired,
    transfer: PropTypes.instanceOf(TransferEnterAor).isRequired,
    updateCommentAction: PropTypes.func.isRequired,
    updateRejectedReason: PropTypes.func,
    updateStatusAction: PropTypes.func.isRequired
};

export default TransferSearchResult;



// WEBPACK FOOTER //
// ./src/product/transfers/components/transfer-search-result.js